import React from 'react';
import PropTypes from 'prop-types';
import SessionTimeout from '@employee/sessiontimeout';

const propTypes = {
    remainingSessionTimeInMs: PropTypes.number.isRequired,
    logoutUrl: PropTypes.string.isRequired,
    renewSessionUrl: PropTypes.string.isRequired
};
const defaultProps = {};

function SessionTimeoutWrapper(props) {
    return <SessionTimeout {...props} />;
}

SessionTimeoutWrapper.propTypes = propTypes;
SessionTimeoutWrapper.defaultProps = defaultProps;
export default SessionTimeoutWrapper;
